import React from 'react';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { refreshFiles } from '../../../redux/slices/fileManagerSlice';
import { Tooltip, IconButton } from '@mui/material';
import { useAppDispatch } from '@/redux/hooks';

const RefreshFiles = ({ className = '' }) => {
  const dispatch = useAppDispatch();

  const onRefresh = (e) => {
    e.stopPropagation();
    dispatch(refreshFiles());
  };

  return (
    <Tooltip title="Refresh Folder">
      <IconButton className={className} color="primary" size="large" onClick={onRefresh}>
        <PolarisIcon icon="refresh" height={20} />
      </IconButton>
    </Tooltip>
  );
};

export default RefreshFiles;
